export default "__VITE_ASSET__BJrjfzNc__"